/**
 * One-time cleanup of the on-device whisper model.
 *
 * Voice search used to download a ~31 MB ggml model and keep it in a Cache
 * Storage entry so it survived HTTP-cache eviction. Transcription now runs
 * server-side via POST /Voice/Transcribe, so that entry is dead weight — but
 * it does not disappear on its own. Every user who ran the old build still has
 * it, and Cache Storage counts against their origin quota, so without this
 * they carry 31 MB forever for a feature that no longer exists.
 *
 * Deliberately matches by prefix rather than one exact name: the cache was
 * versioned per model ("whisper-model-tiny.en-q5_1-v1" was only the last of
 * them), and a user who skipped a release may hold an earlier one.
 */
const LEGACY_CACHE_PREFIX = "whisper-model-";

let done = false;

export function purgeLegacyModelCache(): void {
  if (done) return;
  done = true;

  // Cache Storage is unavailable on insecure origins and in some private
  // modes. Nothing here is required for voice search to work.
  if (typeof caches === "undefined") return;

  void (async () => {
    try {
      const names = await caches.keys();
      const stale = names.filter((name) => name.startsWith(LEGACY_CACHE_PREFIX));
      await Promise.all(stale.map((name) => caches.delete(name)));
    } catch {
      // Best effort — a failure here costs disk space, never correctness.
    }
  })();
}
